import { ConciergeAvatar } from "@/components/brand/ConciergeAvatar";

/** Animated "concierge is typing" indicator shown while a reply is pending. */
export function TypingIndicator() {
  return (
    <div className="flex animate-rise items-end gap-2.5">
      <ConciergeAvatar size={34} active className="mb-0.5" />
      <output
        aria-label="컨시어지가 입력 중입니다"
        className="flex items-center gap-1.5 rounded-[1.25rem] rounded-bl-md border border-border/60 bg-card px-4 py-3.5 shadow-xs"
      >
        <span className="h-1.5 w-1.5 rounded-full bg-primary/70 animate-typing-dot [animation-delay:0ms]" />
        <span className="h-1.5 w-1.5 rounded-full bg-primary/70 animate-typing-dot [animation-delay:150ms]" />
        <span className="h-1.5 w-1.5 rounded-full bg-primary/70 animate-typing-dot [animation-delay:300ms]" />
      </output>
    </div>
  );
}
